import { Avatar, Box, Button, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector, } from "../../store/hooks";

import CustomTextField from '../FormFields/CustomTextField';
import { updateAccountingData } from '../../store/accountThunk';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import LoadingButton from '@mui/lab/LoadingButton';
// import CustomCheckbox from '../FormFields/CustomCheckbox';

import { ApiStatus } from "../../utils/api.types";
import { StyledInput } from '../Dialog/Dialog.styles';

interface DialogAccountingFormProps {
  open: boolean;
  data: any;
  onClose: (k: any) => void;
}

const DialogAccountingForm: FC<DialogAccountingFormProps> = ({ onClose, open, children, data }) => {

  const dispatch = useAppDispatch();

  const { accountDetails, status } = useAppSelector(state => state.account);
  const [formSubmitted, setFormSubmitted] = useState(false);
  // const [isGpayVerified, setisGpayVerified] = useState(true);
  const [image, setImage] = useState("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  // Schema to validate account form.
  const schema = yup.object().shape({
    // taxIdentificationNumber: yup.string().required("Tax identification is required."),
    // upiId: yup.string().required("UPI ID is required."),
    // gPayPhone: yup.string().required("GPay number is required."),
    qrCodeUrl: yup.string()
  });

  const methods = useForm<any>({ mode: 'onTouched', resolver: yupResolver(schema) });

  const handleSelectFile = (event: any) => {
    const target = event.target as HTMLInputElement;

    if (target.files && target.files[0]) {
      setSelectedFile(target.files[0]);
      setImage(URL.createObjectURL(target.files[0]));
    }
  };
  
  const innerSubmit = async (data: any) => {
    const form = new FormData();
    form.append('upiId', data.upiId);
    form.append('gPayPhone', data.gPayPhone);
    // form.append('taxIdentificationNumber', data.taxIdentificationNumber);
   
    if (selectedFile) {
      form.append('qrCodeUrl', selectedFile);
    }
    onSubmit(form);
  };

  const onSubmit = (e: any) => {
    dispatch(updateAccountingData(
      {
        accountingPayload: e,
        id: accountDetails._id
      }));
    setFormSubmitted(true);
  }

  useEffect(() => {
    const setInitialData = () => {
      if (data){
      methods.setValue('upiId', data.upiId);
      methods.setValue('gPayPhone', data.gPayPhone);
      //setisGpayVerified(data.gPayPhoneVerifiedFlag);
      setImage(data.qrCodeUrl);
    }
  }
    setInitialData();
  }, [data, methods]);  

  useEffect(() => {
    if (status === ApiStatus.SUCCESS && formSubmitted) {
      onClose(false);
      setFormSubmitted(false);
    }
  }, [status, formSubmitted, onClose]);

  return (
    <div className="drawer-form-container">
      {/* <FormProvider {...methods}>
      <Box sx={style} component="form" onSubmit={methods.handleSubmit(data => onSubmit(data))} ref={formRef} noValidate>
        <Grid container >
          <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 2, pl: 2, bgcolor: '#e9ecf1' }} style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, height: 50 }} >
            <div style={{ float: 'right', marginTop: -7, marginRight: -5 }}>
              <LoadingButton
                type="submit"
                name={'submit'}
                // disabled={!methods.formState.isValid}
                loading={status === ApiStatus.LOADING}
                style={{ color: '#488dff', backgroundColor: '#fff', border: '1px solid #488dff', marginRight: 10 }}
                variant="contained"
                size='small'>
                {`Save`}
              </LoadingButton>

              <Button
                style={{ color: '#488dff', backgroundColor: '#fff', border: '1px solid #488dff', marginRight: 10 }}
                variant="contained"
                size='small'
                onClick={() => {
                  methods.reset();
                  onClose(false);
                }} >
                Cancel
              </Button>
            </div>
            <h3 style={{ marginTop: -2 }}>Payment Update</h3>
          </Grid>

        </Grid> */}
      <FormProvider {...methods}>
        <Box
          sx={{ display: "flex", flexDirection: "column", height: "100vh", padding: "16px 0 16px 16px" }}
          component="form"
          onSubmit={methods.handleSubmit(innerSubmit)}
          noValidate>
          <DialogTitle>
            <Box sx={{ display: "flex", mt: 2, justifyContent: "space-between" }}>
              <Typography variant="h5">Payment Update</Typography>
            </Box>
          </DialogTitle>

          <DialogContent>
            <Grid container justifyContent="center" spacing={2} rowSpacing={-2}>
              <Grid item xs={12} md={12} sm={12} lg={12}>
                <CustomTextField label="UPI ID" name="upiId" variant="standard" />
              </Grid>

              <Grid item xs={12} md={12} sm={12} lg={12}>
                <CustomTextField min={1} type="number" label="GPay Number" name="gPayPhone"  variant="standard" />
              </Grid>

              <Grid item xs={12} md={12} sm={12} lg={12}>
                  <div style={{ position: "relative", display: "flex", flexDirection: "column", justifyItems: "center", alignItems: "center", marginTop:'30px' }}>
                  <div className="file-name" style={{ marginBottom: "10px" }}>
                  {image && (
                      <Avatar
                        alt={"Picture"}
                        imgProps={{ referrerPolicy: "no-referrer" }}
                        src={image}
                        variant='square'
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "contain",
                        }}
                        sizes={"lg"}
                      />
                      )}
                    </div>
                    <label htmlFor="qrCodeUrl">
                      <StyledInput
                        accept="image/*"
                        id="qrCodeUrl"
                        type="file"
                        onChange={handleSelectFile}
                      />
                      <Button
                        variant="outlined"
                        className="btn-choose"
                        component="span"
                      >
                        Upload QR Code
                      </Button>
                    </label>
                  </div>
                  </Grid>
              {/* <Grid item xs={6} md={6} sm={6} lg={6}>
                <CustomCheckbox
                  label="Gpay verified"
                  name="gPayPhoneVerifiedFlag"
                  checked={isGpayVerified}
                  onChange={(event, checked) => {
                    setisGpayVerified(checked);
                  }}
                />
              </Grid> */}

            </Grid>
          </DialogContent>
        </Box>
      </FormProvider>
    </div >
  );
};

export default DialogAccountingForm;
